export interface Report {
  displayname: string;
  report: string;
  category: string;
  subcategory: string;
  workspacename: string;
  workspaceid: string;
  reportid: string;
  azureSecurityGroupName: string;
  type: 'Report' | 'Paginated Report' | 'Dashboard';
  refreshFrequency?: number; // Minutes
  id?: number;
}

export function createEmptyReport(): Report {
  return {
    displayname: '',
    report: '',
    category: '',
    subcategory: '',
    workspacename: '',
    workspaceid: '',
    reportid: '',
    azureSecurityGroupName: '', 
    type: 'Report',
    refreshFrequency: 0, // 0 means never refresh
  };
}

export const requiredReportFields = [
  'displayname',
  'report',
  'category',
  'subcategory',
  'workspacename',
  'workspaceid',
  'reportid',
  'type',
] as const;

export const optionalReportFields = [
  'azureSecurityGroupName',
  'refreshFrequency',
] as const; 